import { createContext } from "react";

type FeatureFlagContextValue = { flags: Record<string, boolean>; hasLoadedFlags: boolean };
export const FeatureFlagContext = createContext<FeatureFlagContextValue>({ flags: {}, hasLoadedFlags: false });
